import SystemNotifications from 'common/components/SystemNotifications';
import { GlobalStateConsumer } from 'common/apps/core/StateConsumer';
import { useGlobalApi } from 'common/apps/core/ApiConsumer';

import { getNotificationsSelector } from './selectors';
import { NotificationModuleApi } from './types';

const Notifications = () => {
  const api = useGlobalApi<{ notifications: NotificationModuleApi }>();

  return (
    <GlobalStateConsumer selector={getNotificationsSelector}>
      {(notifications) => (
        <SystemNotifications
          notifications={notifications}
          onHide={api.notifications.handleClose}
        />
      )}
    </GlobalStateConsumer>
  );
};

export default Notifications;
